import type { PlayerUser } from "Models";

const ScorecardSearchFormattedOptions = ({
  value,
  context,
}: {
  value: PlayerUser;
  context: any;
}) => {
  return context === "menu" ? (
    <div className="text-sm">
      {value.displayName ? value.displayName : null}{" "}
      {value.username ? (
        <span className="text-gray-500">- {value.username}</span>
      ) : null}
      <br />
      {value.email ? (
        <span className="text-gray-500">{value.email}</span>
      ) : null}
    </div>
  ) : (
    <div>{value.username || value.displayName || value.email}</div>
  );
};
export default ScorecardSearchFormattedOptions;
